import React, { useEffect, useState } from 'react'
import Container from './Container';
import About from './About';
import Works from './Works';
import Footer from './Footer'
import Loading from './Loading';

function MainContainer() {

    const[load,SetLoad]=useState(false);
         
    
        
      useEffect(()=>{
          SetLoad(true)
          setTimeout(()=>{
          SetLoad(false)
          },4000)
      },[])
   





    return (

        <>
        { load ? 
        
           
        <Loading/>
            
         : 
          <>
        <Container/>
        <About/>
        <Works/>
        <Footer/>
        
        </>
         }
    
          </>
        
    )
}


export default MainContainer
